@if (header) {
    <div class="modal-header">
        <h1 class="modal-title fs-5 fw-normal" id="confirm-dialog-title">{{ header }}</h1>
    </div>
    <div class="modal-body" id="confirm-dialog-description">
        <p [class.mb-0]="!message">{{ title }}</p>
        @if (message) {
            <p class="mb-0">{{ message }}</p>
        }
    </div>
} @else {
    <div class="modal-header">
        <h1 class="modal-title fs-5">{{ title }}</h1>
    </div>
    <div class="modal-body">
        <p>{{ message }}</p>
    </div>
}
<div class="modal-footer">
    @if (cancelFirst) {
        <button class="btn {{ confirmCancelClass }} px-3" (click)="modal.dismiss(false)">
            {{ cancelText }}
        </button>
        <button class="btn {{ confirmOkClass }} px-3" (click)="modal.close(true)">
            {{ confirmText }}
        </button>
    } @else {
        <button class="btn {{ confirmOkClass }} px-3" (click)="modal.close(true)">
            {{ confirmText }}
        </button>
        <button class="btn {{ confirmCancelClass }} px-3" (click)="modal.dismiss(false)">
            {{ cancelText }}
        </button>
    }
</div>
